<div class="tabs-medical-record" [ngClass]="{'mac':plataform=='MacIntel'}">

  <div class="tabs-items">
    <div *ngFor="let tab of tabs">
      <div class="tab-chip" (click)="clickTab(tab)"
      [ngClass]="(tabSelected()) == (tab) ? 'tab-chip-selected' : ''">
        {{ tab | uppercase }}
      </div>
    </div>
  </div>
</div>
